import React, { Component } from "react";

import '../../assets/css/streams-page.css';


import {
  InputStreamArray,
  InputStreamDefArray,
  dataSales,
  optionsSales,
  responsiveSales,
  legendSales
} from "../../variables/Variables.jsx";

import {
  Grid
} from "react-bootstrap";

import StreamDetails from "./StreamDetails";
import StreamList from "./StreamList";
import StreamTSDetails from "./StreamTSDetails";


class Streams extends Component {
  render() {
    return (
      <div className="content">
        <Grid fluid>
          <StreamList />
          <StreamDetails />
          <StreamTSDetails />
        </Grid>
      </div>
    );
  }
}



export default Streams;
